<template>
  <v-dialog persistent v-model="payDialog" width="720px">
    <v-card>
      <v-card-title>
          <span class="headline">
            {{ $t("HuifuAccount.Pay.title") }}
          </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="payDialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
              {{ $t("CRUD.backToList", [$t("HuifuAccount.title")]) }}
            </span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-container>
           <ValidationObserver ref="observer">
          <v-form>
            <v-row>
              <!-- 支付账户 -->
              <v-col cols="6">
                  <span >
                    {{ $t("HuifuAccount.Pay.outExtCode") + $t("Global.colon") }}
                  </span>
                <span class="green--text">
                  {{ baseHuifuId }}
                  </span>
                  <span class="red--text">
                  {{ $t("HuifuAccount.Pay.baseHuifuAccount") }}
                  </span>
              </v-col>
              <!-- 账户余额 -->
              <v-col cols="6">
                  <span>
                    {{ $t("HuifuAccount.Pay.balanceAmt") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money")
                    }}{{ balanceAmt | formatMoney }}
                  </span>
              </v-col>
              <!-- 手续费 -->
              <v-col cols="6">
                  <span>
                    {{ $t("HuifuAccount.Pay.feeAmt") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money")
                    }}{{ 2 | formatMoney }}
                  </span>
              </v-col>
              <!-- 剩余余额 -->
              <v-col cols="6">
                  <span>
                    {{ $t("HuifuAccount.Pay.expectedAmt") }}{{ $t("Global.colon") }}
                  </span>
                <span class="red--text">
                   {{ $t("Global.money")
                    }}{{ expectedAmt | formatMoney }}
                  </span>
              </v-col>
              <!-- 收款账户 -->
              <v-col cols="6">
                  <span >
                    {{ $t("HuifuAccount.Pay.inExtCode") + $t("Global.colon") }}
                  </span>
                <span class="green--text">
                  {{ huifuAccount.huifu_id }}
                  </span>
              </v-col>
              <!-- 收款账户 -->
              <v-col cols="6">
                  <span >
                    {{ $t("HuifuAccount.Pay.companyName") + $t("Global.colon") }}
                  </span>
                <span class="green--text">
                  {{ huifuAccount.company_name }}
                  </span>
              </v-col>
              <!-- 付款金额-->
              <v-col cols="6">
                     <ValidationProvider
                               v-slot="{ errors }"
                               :name="$t('HuifuAccount.Pay.balancePay')"
                               :rules="{
                                    max_value: {
                                        max: (balanceAmt - 2).toFixed(2),
                                    },
                                    min_value: {
                                        min: 0.01,
                                    },
                                    required: {
                                        required: true
                                    }
                                }"
                       >
                    <span class="d-flex">
                    {{ $t("HuifuAccount.Pay.balancePay") }}{{ $t("Global.colon") }}
                    <v-text-field
                            v-model="balancePay"
                            single-line
                            dense
                            type="number"
                            min="0"
                            :disabled="isBalancePayDisabled"
                            :prefix="$t('Global.money')"
                            :error-messages="errors"
                            @blur="balancePay = $numberFormatter.formatMoney(balancePay)"
                    ><template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                    </span>
                  </ValidationProvider>
              </v-col>
              <!-- 验证码 -->
              <v-col cols="6" v-if="isBalancePayDisabled">
                  <span class="d-flex">
                    {{ $t("HuifuAccount.Pay.VCode") }}{{ $t("Global.colon") }}
                    <v-text-field
                            v-model="VCode"
                            single-line
                            dense
                            persistent-hint
                            :hint="$t('HuifuAccount.vc_code_hint')"
                    />
                  </span>
                </v-col>
            </v-row>
          </v-form>
           </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="payDialog = false">{{ $t("$vuetify.close") }}</v-btn>
        <v-btn color="accent" @click="submit()">{{ $t("CRUD.confirm") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import Settings from "@/api/settings";
import HfdgInterface from "@/api/hfdgInterface";
import ThirdAccountInfo from "@/api/third-account-info"
import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
    name: "PayDialog",

    props: {
        value: Boolean,
        item: Object
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({
        payDialog: false,
        huifuAccount: {},
        settingKeys: {
            keys: [
                "hfdgpay_huifu_id", // 汇付总账户ID
            ]
        },
        baseHuifuId: "",
        balanceAmt: 0,
        expectedAmt: 0,
        balancePay: null,
        VCode: null,
        payCode: null,
        isBalancePayDisabled: false,
    }),
    mounted() {

    },
    methods: {
        getSettings() {
            //获取汇付总账户ID
            Settings.getSettings(this.settingKeys).then((settingResponse) => {
                if (settingResponse.data.status.isOK()) {
                    this.baseHuifuId = settingResponse.data.settings.hfdgpay_huifu_id;
                    if (this.baseHuifuId) {
                        HfdgInterface.getWithdraw({huifu_id: this.baseHuifuId}).then((response) => {
                            if (response.data.status.isOK()) {
                                this.expectedAmt = this.balanceAmt = parseFloat(response.data.data[0].balance_amt).toFixed(2)
                            }
                        })
                    }
                }
            })
        },
        submit() {
            if (!this.isBalancePayDisabled) {
                this.$refs.observer.validate().then(
                    async function (result) {
                        if (result) {
                            let submitData = {
                                balance_pay: this.balancePay,
                                pay_type: 101, // TODO 支付类型：汇付：101（暂时）
                                huifu_id: this.huifuAccount.huifu_id
                            }
                            ThirdAccountInfo.addHfdgBalancePay(submitData).then((payResponse) => {
                                if (payResponse.data.status.isOK()) {
                                    this.payCode = payResponse.data.third_pay_records.pay_code
                                    if (payResponse.data.mobile_validation_flg && payResponse.data.mobile_validation_code != '') {
                                        let submitData = {
                                            pay_code: this.payCode,
                                            validation_code: payResponse.data.mobile_validation_code
                                        }
                                        HfdgInterface.balancePay(submitData).then(
                                            function (response) {
                                                if (response.data.status.isOK()) {
                                                    this.$snackbar.success(i18n.t("HuifuAccount.Pay.successMsg"));
                                                    this.payDialog = false
                                                }
                                            }.bind(this)
                                        )
                                    }else {
                                        ThirdAccountInfo.mobileValidation({third_record_code: this.payCode, type: 1}).then((response) => {
                                            if (response.data.status.isOK()) {
                                                this.$snackbar.success(i18n.t("HuifuAccount.Pay.mobileVCode"));
                                                this.isBalancePayDisabled = true
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }.bind(this)
                )
            }else if (this.VCode != '') {
                let submitData = {
                    pay_code: this.payCode,
                    validation_code: this.VCode
                }
                HfdgInterface.balancePay(submitData).then(
                    function (response) {
                        if (response.data.status.isOK()) {
                            this.$snackbar.success(i18n.t("HuifuAccount.Pay.successMsg"));
                            this.payDialog = false
                        }
                    }.bind(this)
                )
            }
        },
    },

    watch: {
        value: {
            immediate: false, //初始赋值也调用
            handler() {
                if (this.value) {
                    this.getSettings();
                } else {
                    this.huifuAccount = {};
                    this.balancePay = null;
                    this.baseHuifuId = "";
                    this.balanceAmt = 0;
                    this.expectedAmt = 0;
                    this.VCode = null;
                    this.payCode = null;
                    this.isBalancePayDisabled = false
                    this.$refs.observer.reset();
                }
                this.payDialog = this.value;
            },
        },
        item: {
            immediate: false, //初始赋值也调用
            handler() {
                this.huifuAccount = this.item;
            },
        },
        payDialog: {
            handler() {
                this.$emit("input", this.payDialog);
            },
        },
        balancePay: {
            handler() {
                if (!this.balancePay) {
                    this.expectedAmt = this.balanceAmt
                } else {
                    this.expectedAmt = this.balanceAmt - this.balancePay - 2;
                }
            }
        }
    },
};
</script>